// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2olRK","footer":"ChangeClinic_footer__231XX"};